import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslate } from 'hooks/useTranslate';
import { useCompleteOperationModal } from '../context/CompleteOperationModalContext';

const CompleteOperationModalBody: FC = () => {
  const { t } = useTranslate();
  const { data } = useCompleteOperationModal();

  return (
    <Modal.Body>
      <div className="nk-modal">
        <div className="alert alert-warning mb-3">
          <em className="icon ni ni-alert-circle mr-2" />
          <strong>{t('IrreversibleActionWarning')}</strong>
        </div>

        <p className="text-soft mb-3">{t('CompleteOperationContractInfo')}</p>

        <div className="card card-bordered">
          <div className="card-inner py-3">
            <div className="row g-2">
              <div className="col-sm-6">
                <p className="mb-1 text-soft fs-12px">{t('Buyer')}</p>
                <strong className="d-block">{data.buyerName || '-'}</strong>
              </div>
              <div className="col-sm-6">
                <p className="mb-1 text-soft fs-12px">{t('Seller')}</p>
                <strong className="d-block">{data.sellerName || '-'}</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal.Body>
  );
};

export default CompleteOperationModalBody;
